import { render } from "./DetailsPassings.vue?vue&type=template&id=225cf246&scoped=true"
import script from "./DetailsPassings.vue?vue&type=script&lang=js"
export * from "./DetailsPassings.vue?vue&type=script&lang=js"

import "./DetailsPassings.vue?vue&type=style&index=0&id=225cf246&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225cf246"]])

export default __exports__